import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
        <Path
            fill={props.color ?? ds.colorValue.icon.primary}
            d="M6.26 3.009c.768-1.344 2.705-1.344 3.473 0l4.574 8.005c.761 1.333-.201 2.992-1.736 2.992H3.422c-1.535 0-2.498-1.66-1.736-2.992L6.26 3.009Zm1.736 7.738a.75.75 0 0 0-.75.75v.255a.75.75 0 0 0 1.5 0v-.255a.75.75 0 0 0-.75-.75Zm0-5.765a.75.75 0 0 0-.75.75v2.511a.75.75 0 0 0 1.5 0v-2.51a.75.75 0 0 0-.75-.75Z"
        />
    </Svg>
);

export { SvgComponent as AlertTriangleWhiteSmall };
